import React from "react";

/**
 * WageUp Logo — Premium fintech-style mark.
 * A rounded-square gradient badge containing a bold "W" whose final stroke
 * extends upward into a gold arrow — symbolizing wages going up.
 */
export const WageUpLogo = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="wu-bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#C4231D" />
        <stop offset="60%" stopColor="#A61B1B" />
        <stop offset="100%" stopColor="#6B0F0F" />
      </linearGradient>
      <linearGradient id="wu-arrow" x1="0" y1="1" x2="1" y2="0">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#FCD34D" />
      </linearGradient>
      <filter id="wu-shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="1.5" stdDeviation="1.2" floodOpacity="0.25" />
      </filter>
    </defs>

    {/* Rounded-square badge with subtle highlight */}
    <rect x="2" y="2" width="60" height="60" rx="14" fill="url(#wu-bg)" />
    <rect x="2" y="2" width="60" height="30" rx="14" fill="white" opacity="0.06" />

    {/* The "W" — 4 bold strokes, the rightmost curving upward into an arrow */}
    <g filter="url(#wu-shadow)">
      <path
        d="M14 22 L20 48 L27 30 L33 48 L40 22"
        stroke="white"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Rising arrow continuation */}
      <path
        d="M40 22 L52 10"
        stroke="url(#wu-arrow)"
        strokeWidth="5.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Arrowhead */}
      <path
        d="M45 10 L52 10 L52 17"
        stroke="url(#wu-arrow)"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>

    {/* Tiny sparkle accent */}
    <circle cx="50" cy="50" r="2" fill="#FCD34D" opacity="0.85" />
  </svg>
);

/**
 * Full wordmark + tagline lockup. Use in headers.
 */
export const WageUpLockup = ({ logoSize = 36, tone = "dark", className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <WageUpLogo size={logoSize} />
    <div className="leading-none">
      <div className={`font-extrabold tracking-tight ${tone === "light" ? "text-white" : "text-stone-900"}`}
           style={{ fontSize: logoSize * 0.62, letterSpacing: "-0.02em" }}>
        WageUp
      </div>
      <div className={`uppercase tracking-[0.18em] mt-0.5 ${tone === "light" ? "text-white/75" : "text-stone-500"}`}
           style={{ fontSize: Math.max(8, logoSize * 0.22) }}>
        Powered by AV Tech
      </div>
    </div>
  </div>
);

export default WageUpLogo;
